import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getCompanyName } from 'modules/playbook/selectors'
import { setValueProp } from 'modules/playbook/actions'
import { getDemoRequestProductName, getDemoRequestValueProp } from 'modules/playbook/selectors'
import ValuePropStep from 'layouts/OnboardingPlaybookDemoRequestStep/ValuePropStep'

const mapStateToProps = (state) => {
  return {
    companyName: getCompanyName(state),
    productName: getDemoRequestProductName(state),
    valueProp: getDemoRequestValueProp(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setValueProp,
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ValuePropStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/DemoRequestSteps/ValueProp/index.js